"use client";

import { useTranslations } from "@/app/(site)/europe/useTranslations";
import { brands } from "./constants";
import { PageSection, ResponsiveVadImage } from "@components";

export const TopBrandsWall = () => {
  const { trustedByTopBrands } = useTranslations();

  return (
    <PageSection>
      <h4 className="text-center font-semibold text-4xl mb-28">{trustedByTopBrands}</h4>
      <div className="grid grid-cols-3 md:grid-cols-4 gap-12 items-center">
        {brands.slice(0, brands.length - 3).map((b) => (
          <ResponsiveVadImage
            key={`brand-wall-${b.imageName}`}
            src={`/images/european-lander/brands/${b.imageName}`}
            alt={`brand-wall-${b.imageName}`}
            width={b.imgWidth}
            height={b.imgHeight}
            mobileSrc={`/images/european-lander/brands/${b.imageName}`}
            mobileAlt={`brand-wall-${b.imageName}`}
            mobileWidth={b.imgWidth * 0.63}
            mobileHeight={b.imgHeight * 0.63}
            className="mx-auto"
            mobileClassName="mx-auto"
          />
        ))}
      </div>
      <div className="hidden md:flex flex-wrap justify-around items-center mt-12">
        {brands.slice(brands.length - 3).map((b) => (
          <ResponsiveVadImage
            key={`brand-wall-${b.imageName}`}
            src={`/images/european-lander/brands/${b.imageName}`}
            alt={`brand-wall-${b.imageName}`}
            width={b.imgWidth}
            height={b.imgHeight}
            mobileSrc={`/images/european-lander/brands/${b.imageName}`}
            mobileAlt={`brand-wall-${b.imageName}`}
            mobileWidth={b.imgWidth * 0.63}
            mobileHeight={b.imgHeight * 0.63}
            className="mx-auto"
            mobileClassName="mx-auto"
          />
        ))}
      </div>
      <div className="md:hidden flex flex-wrap justify-around items-center mt-12">
        {[brands[brands.length - 1], brands[brands.length - 3]].map((b) => (
          <ResponsiveVadImage
            key={`brand-wall-${b.imageName}`}
            src={`/images/european-lander/brands/${b.imageName}`}
            alt={`brand-wall-${b.imageName}`}
            width={b.imgWidth}
            height={b.imgHeight}
            mobileSrc={`/images/european-lander/brands/${b.imageName}`}
            mobileAlt={`brand-wall-${b.imageName}`}
            mobileWidth={b.imgWidth * 0.63}
            mobileHeight={b.imgHeight * 0.63}
            className="mx-auto"
            mobileClassName="mx-auto"
          />
        ))}
      </div>
      <div className="md:hidden flex items-center justify-center mt-12">
        <ResponsiveVadImage
          key={`brand-wall-${brands[brands.length - 2].imageName}`}
          src={`/images/european-lander/brands/${brands[brands.length - 2].imageName}`}
          alt={`brand-wall-${brands[brands.length - 2].imageName}`}
          width={brands[brands.length - 2].imgWidth}
          height={brands[brands.length - 2].imgHeight}
          mobileSrc={`/images/european-lander/brands/${brands[brands.length - 2].imageName}`}
          mobileAlt={`brand-wall-${brands[brands.length - 2].imageName}`}
          mobileWidth={brands[brands.length - 2].imgWidth * 0.63}
          mobileHeight={brands[brands.length - 2].imgHeight * 0.63}
          className="mx-auto"
          mobileClassName="mx-auto"
        />
      </div>
    </PageSection>
  );
};
